import { useGetClinics } from "../../hooks/useGetClinics";
import ClearableSelect from "./ClearableSelect";

export default function ClinicFilter({
  param = "clinic",
  deleteParams = ["clinic"],
}) {
  const { data, isLoading, error } = useGetClinics();

  const clinicSelectOptions = [
    { value: -1, label: "NoClinic" },
    ...(data?.map(({ id, title }) => ({
      value: id,
      label: title,
    })) || []),
  ];

  return (
    <ClearableSelect
      param={param}
      deleteParams={deleteParams}
      label="Clinic"
      options={clinicSelectOptions}
      disabled={isLoading || error}
      testId="users.page.filters.clinic-select"
    />
  );
}
